import axiosApi from "../api/axiosInstance";
import { CheckPhone_URL, UpdateCustomerProfile_URL } from "./config";

export async function fetchBalance() {
  try {
    // If server expects cookie auth: include credentials
    const resp = await axiosApi.get("/api/v2/customer/getUserBalance");
    // controller returns { success: true, data: ... }
    // console.log("Balance fetched successfully");
    if (resp.data) return resp.data;
    throw new Error("Unexpected response: " + JSON.stringify(resp.data));
  } catch (err) {
    console.error("fetchBalance error", err);
    throw err;
  }
}

// fetch customerDetails
export async function fetchCurrentUser() {
  try {
    // If server expects cookie auth: include credentials
    const resp = await axiosApi.get("/api/v2/customer/getCurrentUser", {
      skipUnauthorizedEvent: true,
    });
    //console.log("fetchCurrentUser response:", resp);

    if (resp.data && resp.status) return resp.data;
  } catch (err) {
    // console.error("fetchCurrentUser error", err);
    throw err;
  }
}

//update customer profile
// data : object with customer profile fields to update
// export async function updateCustomerProfile(data) {
//   try {
//     console.log("********** Updating customer profile **********");
//     console.log("updateCustomerProfile data:", data);
//     console.log("*********************************************");

//     const resp = await axiosApi.post(UpdateCustomerProfile_URL, data);

//     console.log("updateCustomerProfile response:", resp);

//     // ✅ Return response even if success is false (to handle Sonic API errors)
//     if (resp.data) return resp.data;

//     throw new Error("Unexpected response: " + JSON.stringify(resp.data));
//   } catch (err) {
//     // console.error("updateCustomerProfile error", err);
//     throw err;
//   }
// }

export async function updateCustomerProfile(data) {
  try {
    // console.log("********** Updating customer profile **********");
    // console.log("updateCustomerProfile data:", data);
    // console.log("*********************************************");

    const resp = await axiosApi.post(UpdateCustomerProfile_URL, data);

    // console.log("updateCustomerProfile response:", resp.data);

    // ✅ Always return the response data (backend handles success/failure)
    return resp.data;
  } catch (err) {
    console.error("updateCustomerProfile error", err);

    // ✅ If backend returned an error response, extract it
    if (err.response?.data) {
      return {
        success: false,
        message: err.response.data.message || "Profile update failed",
      };
    }

    throw err;
  }
}

/**
 * Fetch order history.
 * - summary: if true returns dashboard summary (lastOrders, lastOrderNetTotal)
 * - limit: optional number of orders to return when summary=true
 */
// export async function fetchOrdersHistory({ summary, limit } = {}) {
//   try {
//     const params = {};
//     if (summary) params.summary = "true"; // explicit
//     if (limit) params.limit = Number(limit);

//     console.log("fetchOrdersHistory params:");
//     console.log(params);
//     console.log("-----------------------------");

//     const resp = await axiosApi.get("/api/v2/customer/getOrderHistory", {
//       params,
//     });

//     console.log("fetchOrdersHistory response:", resp);
//     console.log(resp.data);
//     console.log("-----------------------------");

//     if (!resp?.data) throw new Error("No response data");
//     if (!resp.data.success)
//       throw new Error("API error: " + JSON.stringify(resp.data));

//     // For summary call, server returns { lastOrders, lastOrderNetTotal, ordersCount }
//     return resp.data.data;
//   } catch (err) {
//     // console.error("fetchOrdersHistory error", err);
//     throw err;
//   }
// }

export async function fetchOrdersHistory({ summary = false, limit } = {}) {
  try {
    const params = {};
    if (summary) params.summary = "true";
    if (limit) params.limit = Number(limit);

    // console.log("fetchOrdersHistory params:");
    // console.log(params);
    // console.log("-----------------------------");

    const resp = await axiosApi.get("/api/v2/customer/getOrderHistory", {
      params,
    });

    // console.log("fetchOrdersHistory response:", resp);
    // console.log(resp.data);
    // console.log("-----------------------------");

    if (!resp?.data) throw new Error("No response data");
    if (!resp.data.success)
      throw new Error("API error: " + JSON.stringify(resp.data));

    // For summary call, server returns { lastOrders, lastOrderNetTotal, ordersCount }
    return resp.data.orders; // Changed from resp.data.data to resp.data.orders
  } catch (err) {
    throw err;
  }
}

/**
 *
 * Fetch last Order
 */

export async function fetchLastOrder() {
  try {
    const resp = await axiosApi.get("/api/v2/customer/getLastOrder");

    // console.log("fetchLastOrder response:", resp);
    // console.log(resp.data);
    // console.log("-----------------------------");

    if (!resp?.data) throw new Error("No response data");
    if (!resp.data.success)
      throw new Error("API error: " + JSON.stringify(resp.data));

    return resp.data;
  } catch (err) {
    // console.error("fetchLastOrder error", err);
    throw err;
  }
}

export async function fetchPaymentsHistory({
  summary = false,
  limit = 5,
} = {}) {
  try {
    const params = {};
    if (summary) params.summary = "true";
    if (limit) params.limit = Number(limit);

    // console.log("fetchPaymentsHistory params:");
    // console.log(params);
    // console.log("-----------------------------");

    const resp = await axiosApi.get("/api/v2/customer/getPaymentHistory", {
      params,
    });

    // console.log("fetchPaymentsHistory response:", resp);
    // console.log(resp.data);
    // console.log("-----------------------------");

    if (!resp?.data) throw new Error("No response data");
    if (!resp.data.success)
      throw new Error("API error: " + JSON.stringify(resp.data));

    // For summary call, server returns { lastPayments, lastPaymentAmount, paymentsCount }
    //return resp.data.data;

    if (summary) {
      return {
        lastPayments: resp.data.data.lastPayments,
        lastPaymentAmount: resp.data.data.lastPaymentAmount,
        paymentsCount: resp.data.data.paymentsCount,
        data: resp.data.data,
      };
    } else {
      return resp.data.payments;
    }
  } catch (err) {
    throw err;
  }
}

// fetch customer Wallet status
export async function fetchWalletStatus() {
  try {
    const url = process.env.REACT_APP_ZULAL_API_URL;

    const resp = await axiosApi.get(
      `${url}/api/v2/customer/wallet/activationstatus`
    );

    // console.log("fetchWalletStatus response:", resp);
    // console.log(resp.data);
    // console.log("-----------------------------");

    if (!resp?.data) throw new Error("No response data");
    if (!resp.data.success)
      throw new Error("API error: " + JSON.stringify(resp.data));

    return resp.data;
  } catch (err) {
    console.error("fetchWalletStatus error", err);
    throw err;
  }
}

export async function requestWalletActivation() {
  try {
    const url = process.env.REACT_APP_ZULAL_API_URL;

    const resp = await axiosApi.post(
      `${url}/api/v2/customer/wallet/sendactivationrequest`
    );

    // console.log("requestWalletActivation response:", resp);
    // console.log(resp.data);
    // console.log("-----------------------------");

    if (!resp?.data) throw new Error("No response data");
    if (!resp.data.success)
      throw new Error("API error: " + JSON.stringify(resp.data));

    // console.log("Wallet activation request successful:", resp.data);

    return resp.data;
  } catch (err) {
    console.error("requestWalletActivation error", err);
    throw err;
  }
}

export async function getLatestWalletActivationRequest() {
  try {
    const url = process.env.REACT_APP_ZULAL_API_URL;

    const resp = await axiosApi.get(
      `${url}/api/v2/customer/wallet/getlatestwalletactivationrequest`
    );

    // console.log("getLatestWalletActivationRequest response:", resp);
    // console.log(resp.data);
    // console.log("-----------------------------");

    if (!resp?.data) throw new Error("No response data");
    if (resp.data.success)
      throw new Error("API error: " + JSON.stringify(resp.data));

    return resp;
  } catch (err) {
    console.error("getLatestWalletActivationRequest error", err);
    throw err;
  }
}

// check if phone number exists
// summary: if exists is true, phone number exists in the system, success indicates API call success
// response : { exists: true/false, success: true/false }

const PHONE_REGEX = /^\+?[0-9]{7,15}$/; // expected format (e.g. UAE numbers)

export const checkPhoneExists = async (mobileNumber) => {
  const sanitized = String(mobileNumber).trim();

  if (!PHONE_REGEX.test(sanitized)) {
    throw new Error("Invalid phone number format");
  }

  try {
    const response = await axiosApi.get(CheckPhone_URL, {
      params: { phoneNumber: sanitized },
    });
    return response.data;
  } catch (err) {
    console.error("Error checking phone existence: ", err.message);
    throw err;
  }
};

export const getStates = async (countryId) => {
  try {
    const response = await axiosApi.get("/api/v2/sonic/geo/getStates", {
      params: { countryId },
    });

    // console.log("getStates response:", response.data);

    return response.data.data.data;
  } catch (error) {
    console.error("Error fetching states: ", error.message);
    throw error;
  }
};

export const getCities = async (StateId) => {
  try {
    // Don't make the call if stateId is missing
    if (!StateId) {
      // console.log("getCities: stateId is missing, skipping API call");
      return []; // Return empty array instead of throwing error
    }

    const response = await axiosApi.get("api/v2/sonic/geo/getCities", {
      params: { StateId },
    });

    // console.log("getCities response:", response.data);

    return response.data.data.data; // Adjust based on your response structure
  } catch (error) {
    console.error("Error fetching cities: ", error.message);
    throw error;
  }
};

export const getAreas = async (CityId) => {
  try {
    if (!CityId) {
      console.log("getAreas: cityId is missing, skipping API call");

      return []; // Return empty array instead of throwing error
    }

    const response = await axiosApi.get("/api/v2/sonic/geo/getAreas", {
      params: { CityId },
    });
    return response.data.data.data;
  } catch (error) {
    console.error("Error fetching areas: ", error.message);
    throw error;
  }
};

export const getMosquesByAreaId = async (areaId) => {
  if (!areaId) return [];
  const res = await axiosApi.get("/api/v2/mosque/mosqueslist", {
    params: { areaId },
  });
  return res.data?.data ?? [];
};

export const getpbStates = async (CountryId) => {
  try {
    const response = await axiosApi.get("/api/v2/geo/states/" + CountryId);
    return response.data.data.data;
  } catch (error) {
    console.error("Error fetching states: ", error.message);
    throw error;
  }
};

export const getpbCities = async (StateId) => {
  try {
    const response = await axiosApi.get("/api/v2/geo/cities/" + StateId);
    return response.data.data.data;
  } catch (error) {
    console.error("Error fetching cities: ", error.message);
    throw error;
  }
};

export const getpbAreas = async (CityId) => {
  try {
    const response = await axiosApi.get("/api/v2/geo/areas/" + CityId);
    return response.data.data.data;
  } catch (error) {
    console.error("Error fetching areas: ", error.message);
    throw error;
  }
};
